'use strict';

var RectClip = function RectClip() {
  return function () {
    var _x = 0;
    var _y = 0;
    var _width = 0;
    var _height = 0;
    var _id = 'default-clip';
    function RectClip(container) {
      container.selectAll('#' + _id).remove();
      container.append('clipPath').attr('id', _id).append('rect').attr('x', _x).attr('y', _y).attr('width', _width).attr('height', _height);
    }
    RectClip.id = function (id) {
      _id = id;
      return RectClip;
    };
    RectClip.x = function (x) {
      _x = x;
      return RectClip;
    };
    RectClip.y = function (y) {
      _y = y;
      return RectClip;
    };
    RectClip.height = function (height) {
      _height = height;
      return RectClip;
    };
    RectClip.width = function (width) {
      _width = width;
      return RectClip;
    };
    return RectClip;
  };
};
RectClip.$inject = [];
module.exports = RectClip;